<template>
<a v-bind:class="'kt-font-'+variant" href="#">
    <slot></slot>
</a>
</template>

<script>
export default {
    props: {
        variant: {
            default: 'brand',
        }
    }
}
</script>